export const RecordAudio = {
  Add: {
    Input: {
      Text: {
        LABEL: "Умова вправи",
        PLACEHOLDER: "Опишіть студенту умову вправи",
      },
      Description: {
        LABEL: "Опис",
        PLACEHOLDER: "Напишіть, що потрібно зробити студенту",
      },
      MaxDuration: {
        LABEL: "Максимальна тривалість запису",
        PLACEHOLDER: "Оберіть тривалість",
      },
    },
  },
  Main: {
    Button: {
      RECORD: "Почати запис",
      STOP: "Зупинити",
      RE_RECORD: "Записати знову",
      CONFIRM: "Підтвердити",
    },
    Status: {
      RECORDING: "Запис...",
      UPLOADING: "Зберігається...",
      NO_RECORDING: "Студент ще не надіслав запис",
      LIMIT_REACHED: "Досягнуто ліміту часу",
    },
    Label: {
      MAX_DURATION: (seconds: number): string => {
        if (seconds < 60) return `Максимальна тривалість: ${seconds} сек`;
        return `Максимальна тривалість: ${seconds / 60} хв`;
      },
    },
  },
};
